import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { useBusinessConfig } from '@/hooks/useBusinessConfig';
import { SubscriptionExpiredPage } from './SubscriptionExpiredPage';

interface ProtectedRouteProps {
  isAdmin: boolean;
  children: React.ReactNode;
}

export function ProtectedRoute({ isAdmin, children }: ProtectedRouteProps) {
  const navigate = useNavigate();
  const { config, loading } = useBusinessConfig();
  const [showExpired, setShowExpired] = useState(false);

  useEffect(() => {
    if (!isAdmin) {
      toast.error("Access denied. Please log in.");
      navigate('/');
    }
  }, [isAdmin, navigate]);

  // Check subscription status after auth check
  useEffect(() => {
    if (!config || loading) return;

    const isExpired = config.subscription_status === 'expired' || config.subscription_status === 'cancelled';
    const isTrial = config.subscription_status === 'trial';
    const trialDaysLeft = config.trial_ends_at
      ? Math.max(0, Math.ceil((new Date(config.trial_ends_at).getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
      : 0;
    const trialExpired = isTrial && trialDaysLeft <= 0;

    // Show expired page if subscription is expired or trial has ended
    if (isExpired || trialExpired) {
      setShowExpired(true);
    }
  }, [config, loading]);

  // Show subscription expired page
  if (showExpired) {
    return <SubscriptionExpiredPage />;
  }

  if (!isAdmin) {
    return null;
  }

  return <>{children}</>;
}
